import * as ActionType from '../actions/actionType'
import locales from '../locales'

const initialState = {
  languages: locales.languages,
  currentActive: locales.defaultLanguage
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionType.SWITCH_LANGUAGE:
      return {
        ...state,
        currentActive: action.language
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/language.js